import {RouteDescriptor} from "../../RouteDescriptor";
import {Route} from "../../Route";
import {PlaneApprovalsPage} from "../../../../../pages/Admin/PlaneApprovals/PlaneApprovalsPage";
import {Role} from "../../../roles/Role";
import {defineMessage} from "react-intl";


const AdminPlaneApprovalsRouteTitleMessage = defineMessage({
  id: "adminPlaneApprovalsRoute.title",
  defaultMessage: "Aircraft approvals",
})

export const adminPlaneApprovals: RouteDescriptor<Route.adminPlaneApprovals> = {
  route: Route.adminPlaneApprovals,
  render: PlaneApprovalsPage,
  title: AdminPlaneApprovalsRouteTitleMessage,
  path: '/lk/plane-approvals',
  allowRoles: [
    Role.admin,
  ],
  redirectToHomeRoles: [
  ],
  showInSidebar: true,
}

